import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Lab from './pages/Lab';
import YouTubePlayer from './pages/YouTubePlayer';
import config from './utils/config';

function App() {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [language, setLanguage] = useState('en');

  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
    document.body.classList.toggle('dark');
  };

  const toggleLanguage = () => {
    setLanguage(language === 'ko' ? 'en' : 'ko');
  };

  return (
    <Router basename={config.baseUrl}>
      <div className={`App ${isDarkMode ? 'dark' : ''}`}>
        {config.features.debugMode && (
          <div style={{
            position: 'fixed',
            top: '0',
            left: '0',
            background: '#ff6b6b',
            color: 'white',
            padding: '2px 8px',
            fontSize: '12px',
            zIndex: 9999,
            fontFamily: 'monospace'
          }}>
            DEV MODE
          </div>
        )}
        <Header 
          isDarkMode={isDarkMode} 
          toggleDarkMode={toggleDarkMode}
          language={language}
          toggleLanguage={toggleLanguage}
        />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home language={language} />} />
            <Route path="/about" element={<About language={language} />} />
            <Route path="/lab" element={<Lab language={language} />} />
            <Route path="/youtube-player" element={<YouTubePlayer language={language} />} />
          </Routes>
        </main>
        <Footer language={language} />
      </div>
    </Router>
  );
}

export default App;
